export const VALIDATE_PASSWORD_TOKEN = 'VALIDATE_PASSWORD_TOKEN';
export const VALIDATE_PASSWORD_TOKEN_SUCCESS =
  'VALIDATE_PASSWORD_TOKEN_SUCCESS';
export const VALIDATE_PASSWORD_TOKEN_FAILURE =
  'VALIDATE_PASSWORD_TOKEN_FAILURE';

export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';
export const SET_PASSWORD_FAILURE = 'SET_PASSWORD_FAILURE';

export interface ValidatePasswordToken {
  type: typeof VALIDATE_PASSWORD_TOKEN;
  token: string;
}

export interface ValidatePasswordTokenSuccess {
  type: typeof VALIDATE_PASSWORD_TOKEN_SUCCESS;
}

export interface ValidatePasswordTokenFailure {
  type: typeof VALIDATE_PASSWORD_TOKEN_FAILURE;
}

export interface SetPassword {
  type: typeof SET_PASSWORD;
  password: string;
  token: string;
}

export interface SetPasswordSuccess {
  type: typeof SET_PASSWORD_SUCCESS;
}

export interface SetPasswordFailure {
  type: typeof SET_PASSWORD_FAILURE;
}

export type ActionTypes =
  | ValidatePasswordToken
  | ValidatePasswordTokenSuccess
  | ValidatePasswordTokenFailure
  | SetPassword
  | SetPasswordSuccess
  | SetPasswordFailure;
